import { gql } from 'apollo-boost';

import { COURSE_FRAGMENT } from '../fragments/course-fragment';

export const COURSE_CREATE = gql`
  ${COURSE_FRAGMENT}
  mutation CourseCreate(
    $title: String!
    $description: String!
    $videoUrl: String!
    $imageUrl: String!
    $categories: [ID!]
    $liveLikeAction: String
  ) {
    course_create(
      input: {
        createParams: {
          title: $title
          description: $description
          youtubeUrl: $videoUrl
          imageUrl: $imageUrl
          courseCategoryIds: $categories
          liveLikeAction: $liveLikeAction
        }
      }
    ) {
      course {
        ...courseKeys
      }
    }
  }
`;
